import React from "react";

function Form({ children, className, onSubmit }) {
  return (
    <form className={`Form ${className}`} onSubmit={onSubmit}>
      {children}
    </form>
  );
}

export default Form;
